const defaultState = {
  primaryColor: '#fff',
  fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
  darkTheme: false,
  demoMode: false,
  loaded: false,
  domain: 'hotglue.xyz',
  company: undefined,
  bgColor: undefined,
  hideText: false,
  enableJobPollIndicator: false,
  featureFlags: {},
  isIntervalEnabled: false,
};

export default (state = defaultState, action) => {
  let newState = Object.assign({}, state);
  const { payload, status, type } = action;

  switch (type) {
    case 'FETCH_PREFERENCES':
      if (status == 'success') {
        const { uiPreferences, ...rest } = payload;
        newState = { ...uiPreferences, ...rest };
      }
      newState.loaded = true;
      return newState;
    case 'FETCH_FEATURE_FLAGS':
      newState.featureFlags = payload;
      return newState;
  }

  return state;
};
